import type { NUtils } from '@app/types/Utils';

export const addEnterKeyListener: NUtils.AddEnterKeyListener = ({
  callback,
}) => {
  const listener = (event: KeyboardEvent) => {
    if (event.key === 'Enter') {
      callback();
    }
  };

  window.addEventListener('keyup', listener);

  return () => {
    window.removeEventListener('keyup', listener);
  };
};
